import Button from '../Button';

export type FormModalProps = {
  title: string;
  show: boolean;
  onClose: () => void;
  onAccept: () => void;
  acceptLabel?: string;
  rejectLabel?: string;
  children: React.ReactNode;
};

export default function FormModal({
  title,
  show,
  onClose,
  onAccept,
  acceptLabel = 'Kaydet',
  rejectLabel = 'İptal',
  children,
}: FormModalProps) {
  if (!show) return null;
  return (
    <>
      <div
        className="modal fade show"
        style={{ display: 'block' }}
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Kapat"
              />
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              <Button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                {rejectLabel}
              </Button>
              <Button type="button" className="btn btn-primary" onClick={onAccept}>
                {acceptLabel}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}
